import * as React from 'react';
export const affinSvg = React.forwardRef(function affinSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0067B3',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm23.642 5.011-.011.014.011-.014ZM23.65 5s-3.601 0-5.916 3.494c-1.97 2.973-1.063 6.107-1.063 6.107l1.71-.46c-.448-1.908.16-3.617.844-4.69 1.076-1.693 2.777-2.29 2.862-2.305 1.035-.301 1.342-.29 1.779-.315C23.913 6.073 23.65 5 23.65 5Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22.619 10.792a.896.896 0 1 1-1.793 0 .896.896 0 0 1 1.793 0Zm1.095-2.318a.896.896 0 1 1-1.792 0 .896.896 0 0 1 1.792 0Zm-2.96 4.149a.896.896 0 1 1-1.792 0 .896.896 0 0 1 1.792 0Z',
      fill: '#EE312F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.337 19.555c.907 1.798.796 4.075-.296 5.76a5.9 5.9 0 0 1 .025-6.246c.097.157.188.32.27.486Zm-4.21-2.683c-1.295 1.28-3.237 1.909-5.023 1.61a5.31 5.31 0 0 1-.545-.113 6.112 6.112 0 0 1 1.032-.96 5.931 5.931 0 0 1 4.915-.946 5.855 5.855 0 0 1-.38.406m14.844.479c-2.531-3.15-7.306-3.726-10.512-1.27-.13.097-.26.2-.384.305a7.768 7.768 0 0 0-1.015-.745c.1-.235.188-.478.263-.722 1.454-4.644-1.818-9.484-6.664-9.891-.902 3.651 1.104 7.532 4.603 8.907a5.322 5.322 0 0 0 .113-1.898 5.905 5.905 0 0 1-3.145-4.827c2.816 1.112 4.332 4.393 3.389 7.236a5.849 5.849 0 0 1-.164.454 6.386 6.386 0 0 0-.464-.138c-2.963-.81-6.36.395-8.13 2.912-.348.479-.636.99-.86 1.522a7.78 7.78 0 0 0 1.638.752c2.901.985 6.309 0 8.254-2.379.102-.124.201-.251.298-.381a5.9 5.9 0 0 1 .678.495c-2.354 3.17-1.834 7.756 1.164 10.32 2.874-2.42 3.535-6.74 1.51-9.91a7.914 7.914 0 0 0-.27-.402c.213-.18.442-.346.68-.492 2.266-1.42 5.33-1.087 7.247.832.13.13.255.266.377.41-.183.044-.366.08-.546.108-1.786.284-3.728-.36-5.012-1.65a5.423 5.423 0 0 0-1.77.681c1.815 2.255 5.001 3.314 7.8 2.565a7.735 7.735 0 0 0 2.08-.866 7.858 7.858 0 0 0-1.158-1.931',
      fill: '#fff',
    }),
  );
});
affinSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var affin = {
  category: 'brand',
  colorable: false,
  name: 'affin',
  svg: affinSvg,
};
